import useSWR from 'swr';

import request from '@/utils/request';

export type MobileAssetSettings = {
  retentionDays: number;
  shareBaseUrl: string;
  defaultRetentionDays: number;
  maximumRetentionDays: number;
  objectKeyPattern: string;
  apkShareEnabled: boolean;
};

const apiUrl = '/answer/admin/api/mobile-assets/settings';

export const useMobileAssetSettings = () => {
  const { data, error, mutate } = useSWR<MobileAssetSettings, Error>(
    [apiUrl],
    request.instance.get,
  );

  return { data, error, mutate, isLoading: !data && !error };
};

export const updateMobileAssetSettings = (
  retentionDays: number,
  shareBaseUrl: string,
  apkShareEnabled: boolean,
) =>
  request.put<MobileAssetSettings>(apiUrl, {
    retentionDays,
    shareBaseUrl,
    apkShareEnabled,
  });
